module.exports = __webpack_public_path__ + "img/focus-gzh.7ccab457.png";